import CustomModal from '@/components/CustomModal';
import { AssignmentsIcon, ComputerVideoIcon, Tick01Icon } from '@/icons';
import { cn } from '@/lib/cn';
import { Button, Flex } from 'antd';

interface StageSelectorProps {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  selectedStage: 'assessment' | 'interview';
  setSelectedStage: (stage: 'assessment' | 'interview') => void;
}

export default function StageSelector({
  open,
  onClose,
  onProceed,
  selectedStage,
  setSelectedStage,
}: StageSelectorProps) {
  return (
    <CustomModal
      width={400}
      handleClose={onClose}
      className="hide-modal-title"
      open={open}
    >
      <Flex className="justify-center items-center gap-10 pt-5">
        {/* Assessment Stage */}
        <div
          className="space-y-3 relative group"
          onClick={() => setSelectedStage('assessment')}
        >
          <Flex
            className={cn(
              'cursor-pointer size-[120px] rounded-xl p-5 bg-theme-slate-800 relative transition-all duration-300 border-2',
              selectedStage === 'assessment'
                ? 'border-theme-primary text-theme-primary shadow-[0_0_15px_rgba(var(--theme-primary-rgb),0.2)]'
                : 'border-theme-slate-800 hover:border-theme-primary/30',
            )}
          >
            {selectedStage === 'assessment' && (
              <div className="absolute -top-2 -right-2 p-0.5 rounded-full bg-theme-primary text-white shadow-lg z-10">
                <Tick01Icon size={20} />
              </div>
            )}
            <AssignmentsIcon strokeWidth={1.2} size={80} />
          </Flex>
          <h5
            className={cn(
              'text-base text-center transition-colors duration-300 font-medium',
              selectedStage === 'assessment' ? 'text-theme-primary' : 'text-white/70',
            )}
          >
            Assessment
          </h5>
        </div>

        {/* Interview Stage */}
        <div
          className="space-y-3 relative group"
          onClick={() => setSelectedStage('interview')}
        >
          <Flex
            className={cn(
              'cursor-pointer size-[120px] rounded-xl p-5 bg-theme-slate-800 relative transition-all duration-300 border-2',
              selectedStage === 'interview'
                ? 'border-theme-primary text-theme-primary shadow-[0_0_15px_rgba(var(--theme-primary-rgb),0.2)]'
                : 'border-theme-slate-800 hover:border-theme-primary/30',
            )}
          >
            {selectedStage === 'interview' && (
              <div className="absolute -top-2 -right-2 p-0.5 rounded-full bg-theme-primary text-white shadow-lg z-10">
                <Tick01Icon size={20} />
              </div>
            )}
            <ComputerVideoIcon strokeWidth={1.2} size={80} />
          </Flex>
          <h5
            className={cn(
              'text-base text-center transition-colors duration-300 font-medium',
              selectedStage === 'interview' ? 'text-theme-primary' : 'text-white/70',
            )}
          >
            Interview
          </h5>
        </div>
      </Flex>

      <Button
        onClick={onProceed}
        className="btn-primary w-full mt-8 mb-2 h-11 font-bold text-base"
      >
        Proceed
      </Button>
    </CustomModal>
  );
}
